const ENDPOINT_DOMAIN = `https://graphql.contentful.com`;
const ENDPOINT_HTTP_METHOD = 'POST';

// Error codes: https://www.contentful.com/developers/docs/references/graphql/#/reference/graphql-errors/graphql-errors-explained
const IGNORABLE_ERROR_CODES = {
  /**
   * Contentful throws errors for linked draft references and doesn't provide a
   * way to filter them out in the query. Ignoring these to avoid noise in our logs.
   */
  UNRESOLVABLE_LINK: true,
};

const RETRIABLE_ERROR_CODES = {
  RATE_LIMIT_EXCEEDED: true,
  MOCK_RATE_LIMIT_EXCEEDED: true,
};

const RETRY_CALL_OPTIONS = {
  retries: 5, // maximum amount of times to retry the operation
  factor: 2, // exponential factor to use
  minTimeout: 0.5 * 1000, // number of milliseconds before starting the first retry
  maxTimeout: 10 * 1000, // maximum number of milliseconds between two retries
};

export {
  ENDPOINT_DOMAIN,
  ENDPOINT_HTTP_METHOD,
  IGNORABLE_ERROR_CODES,
  RETRIABLE_ERROR_CODES,
  RETRY_CALL_OPTIONS,
};
